import { useMemo } from "react";
import { useDispatch } from "react-redux";
import { createNotifier } from "../store/common/snackBarSlice";

/**
 * App-wide notifications. The returned function is stable, so it is safe to
 * pass down as a prop or list in effect deps.
 *
 *   const notify = useSnackBar();
 *   notify.success("Order saved");
 *   notify.error(error?.response?.data?.message); // empty → generic error text
 *
 * Existing setSnack call shapes keep working unchanged:
 *   setSnack({ open: true, text, severity: "error" });
 *   setSnack((prev) => ({ ...prev, open: true, text, severity }));
 */
export const useSnackBar = () => {
  const dispatch = useDispatch();
  return useMemo(() => createNotifier(dispatch), [dispatch]);
};
